import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaEye, FaHome } from 'react-icons/fa';
import '../admin/ClerkData.css';
import { API } from '../components/api';
import { FormAPI } from '../components/api';
import Footer from './Footer';
import Header from './Header';
import { useNavigate } from 'react-router-dom';

const AssistantData = () => {
  const navigate = useNavigate();
  const [assistantData, setAssistantData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null); // For modal
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetch(API.getAllUsers)
      .then(res => res.json())
      .then(data => {
        const filtered = Array.isArray(data.assistantApplicants)
          ? data.assistantApplicants
          : [];
        setAssistantData(filtered);
      })
      .catch(err => console.error('Error fetching assistant data:', err));
  }, []);

  const handleView = async (row) => {
    try {
      const response = await fetch(FormAPI.getFormById(row.id, 2));
      const data = await response.json();
      setSelectedUser(data); // Store form data
      setShowModal(true);    // Show modal
    } catch (err) {
      console.error('Error fetching form data:', err);
      alert('Error loading user data');
    }
  };

  const columns = [
    {
      name: 'Sr No',
      selector: (row, index) => index + 1,
      width: '80px',
    },
    {
      name: 'Name',
      selector: row => `${row.last_name} ${row.name} ${row.father_name}` || '-',
      sortable: true,
    },
    {
      name: 'Mobile',
      selector: row => row.mobile || '-',
    },
    {
      name: 'Address',
      selector: row => row.address || '-',
    },
    {
      name: 'Email',
      selector: row => row.email || '-',
    },
    {
      name: 'View',
      cell: row => (
        <FaEye
          style={{ cursor: 'pointer', color: 'blue' }}
          onClick={() => handleView(row)}
        />
      ),
      button: true,
    },
  ];
  
const handleDownload = async (flag) => {
  const excelUrl = API.getExcelDownload(flag); 
  try {
    const response = await fetch(excelUrl);  

    if (!response.ok) {
      const errorData = await response.json(); 
      throw new Error(errorData.message || 'Failed to download the file.');
    }

    window.open(excelUrl, '_blank'); 

  } catch (err) {
    alert('Error downloading the file. Please try again.');
    console.error("Download Error:", err);
  }
};

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  return (
    <>
      <Header />
      <div className="admin-menu">
        <span className="menu-item" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
          <FaHome /> होम पेज
        </span>
        <span className="menu-item" onClick={() => navigate('/clerk')} style={{ cursor: 'pointer' }}>
          कनिष्ठ लिपिक
        </span>
        <span className="menu-item" onClick={() => navigate('/assistant')} style={{ cursor: 'pointer' }}>
          प्रयोगशाळा सहाय्यक
        </span>
      </div>

      <div className='new-container'>
      <div className="assistant-data-container">
        <h2>प्रयोगशाळा सहाय्यक अर्जांची यादी</h2>
        <button onClick={() => handleDownload(2)} className="download-btn">
          Download Assistant Excel
        </button>
        <DataTable
          columns={columns}
          data={assistantData}
          pagination
          responsive
          highlightOnHover
          striped
          className="custom-data-table"
        />
        </div>
      </div>

      {showModal && selectedUser && (
  <div style={{
    position: 'fixed',
    top: 0, left: 0,
    width: '100%', height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  }}>
    <div style={{
      backgroundColor: '#fff',
      padding: '20px 30px',
      borderRadius: '10px',
      width: '700px',
      maxHeight: '80vh',
      overflowY: 'auto',
      boxShadow: '0 5px 15px rgba(0,0,0,0.3)'
    }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#333' }}>अर्जदाराची माहिती</h2>
      
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>क्रमांक</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>माहिती</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>सविस्तर</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            const fields = [];
            //let srNo = 1;

            const addRow = (label, value) => {
              fields.push(
                <tr key={label}>
                  <td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}>{fields.length + 1}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{label}</td>
                  <td
                    style={{ border: '1px solid #ccc', padding: '8px', whiteSpace: 'normal' }}
                    dangerouslySetInnerHTML={{ __html: value }}
                  />
                </tr>
              );
            };

            const fullName = `${selectedUser.last_name || ''} ${selectedUser.name || ''} ${selectedUser.father_name || ''}`.trim();
            addRow('संपूर्ण नाव', fullName);
            addRow('पत्रव्यवहाराचा पूर्ण पत्ता', selectedUser.address);
            addRow('जन्मतारीख', selectedUser.date_of_birth);
            addRow('मोबाईल नंबर', selectedUser.mobile);
            addRow('ईमेल आयडी', selectedUser.email);
            addRow('आधार क्रमांक', selectedUser.aadhar_no);
            addRow('इयत्ता १० वी प्राप्त टक्केवारी', selectedUser.tenth_per);
            addRow('इयत्ता १२ वी प्राप्त टक्केवारी', selectedUser.twelth_per);
            addRow('पदवी', selectedUser.choose_degree);
            addRow('पदवी प्राप्त श्रेणी', selectedUser.obtained_grade);
            //addRow('टंकलेखन मराठी ३० शाब्द प्रति गुण / श्रेणी', selectedUser.typing_marathi_grade);
            //addRow('टंकलेखन इंग्रजी ४० शाब्द प्रति गुण / श्रेणी', selectedUser.typing_english_grade);
            addRow('एम.एस.सी.आय.टी परीक्षा प्राप्त टक्केवारी', selectedUser.mscit_per);
            addRow('जात', selectedUser.cast);
            if (selectedUser.cast_certificate) {
              addRow(
                'जात प्रमाणपत्र आहे / नाही',
                `आहे<br/>जात प्रमाणपत्र क्रमांक: ${selectedUser.cast_cert_no || ''}
                <br/>जात प्रमाणपत्र दिनांक: ${selectedUser.date_cast_cert || ''}
                <br/>जात प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव: ${selectedUser.cast_cert_issuing_village || ''}`
              );
            } else {
              addRow('जात प्रमाणपत्र आहे / नाही', 'नाही');
            }
            
            if (selectedUser.cast_validity_certificate) {
              addRow(
                'जात वैधता प्रमाणपत्र आहे / नाही',
                `आहे<br/>जात वैधता प्रमाणपत्र क्रमांक: ${selectedUser.cast_validity_cert_no || ''}
                <br/>जात वैधता प्रमाणपत्र दिनांक: ${selectedUser.date_cast_validity_cert || ''}
                <br/>जात वैधता प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव: ${selectedUser.cast_validity_cert_issuing_village || ''}`
              );
            } else {
              addRow('जात वैधता प्रमाणपत्र आहे / नाही', 'नाही');
            }

            if (selectedUser.ews) {
              addRow(
                'इ.डब्ल्यू.एस प्रमाणपत्र आहे / नाही',
                `आहे<br/>इ.डब्ल्यू.एस प्रमाणपत्र दिनांक: ${selectedUser.ews_cert_date || ''}
                <br/>इ.डब्ल्यू.एस प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव: ${selectedUser.ews_cert_village || ''}
                <br/>इ.डब्ल्यू.एस प्रमाणपत्र वैधता वर्ष: ${selectedUser.ews_cert_validity_year || ''}`
              );
            } else {
              addRow('इ.डब्ल्यू.एस प्रमाणपत्र आहे / नाही', 'नाही');
            }
            
            if (selectedUser.sebc_cert) {
              addRow(
                'एस.ई.बी.सी प्रमाणपत्र आहे / नाही',
                `आहे<br/>एस.ई.बी.सी प्रमाणपत्र दिनांक: ${selectedUser.sebc_cert_date || ''}
                <br/>एस.ई.बी.सी प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव: ${selectedUser.sebc_cert_village || ''}
                <br/>नॉन क्रीमीलेयर वैधता वर्ष: ${selectedUser.non_creamy_validity_year || ''}`
              );
            } else {
              addRow('एस.ई.बी.सी प्रमाणपत्र आहे / नाही', 'नाही');
            }

            return fields;
          })()}
        </tbody>
      </table>

      <button
        onClick={handleCloseModal}
        style={{
          marginTop: '20px',
          padding: '8px 20px',
          backgroundColor: '#d9534f',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          float: 'right'
        }}
      >
        Close
      </button>
    </div>
  </div>
)}

      <Footer />
    </>
  );
};

export default AssistantData;
